import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Button } from '@optimus-web/core';
import { openInBrowserTab, useCommanderSelector } from '@mews-commander/utils';
import { getCurrentEnterpriseCountryCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { BenefitsSection } from '../BenefitsSection';
import { CalculatorPanel } from '../CalculatorPanel';
import { ExtraFundingSection } from '../ExtraFundingSection';
import { FAQSection } from '../FAQSection';
import { MainSection } from '../MainSection';
import { RepaymentPlanSection } from '../RepaymentPlanSection';
import { YoulendFormLinksMap } from '../../constants';

export const PrequalifiedUsers = () => {
    const enterpriseCountryCode: string = useCommanderSelector(getCurrentEnterpriseCountryCode);
    const youlendFormLink =
        typeof enterpriseCountryCode === 'string' && enterpriseCountryCode in YoulendFormLinksMap
            ? YoulendFormLinksMap[enterpriseCountryCode]
            : YoulendFormLinksMap.GB;

    return (
        <>
            <MainSection isConsentTextShown>
                <Button
                    onClick={() => openInBrowserTab(youlendFormLink)}
                    size="large"
                    variant="primary"
                    data-test-id={DataTestId.CapitalApplyNowButton}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.FinancialServicesCapitalButtonText} />
                </Button>
            </MainSection>
            <CalculatorPanel />
            <BenefitsSection />
            <RepaymentPlanSection />
            <ExtraFundingSection />
            <FAQSection />
        </>
    );
};
